import { Alert as AlertWDS, type AlertProps as AlertWDSProps, AlertSeverity } from "@datamole/wds-component-alert";
import { type ReactNode } from "react";

type Props = {
    severity: AlertSeverity;
    title?: ReactNode;
    icon?: ReactNode;
    isIconHidden?: boolean;
    children?: ReactNode;
} & Omit<AlertWDSProps, "severity" | "children" | "title">;

const Alert = (props: Props) => {
    const { severity, title, children, icon, isIconHidden, ...otherProps } = props;

    return (
        <AlertWDS {...otherProps} severity={severity}>
            {!isIconHidden && <AlertWDS.Icon>{icon}</AlertWDS.Icon>}
            <AlertWDS.Content>
                {title && <AlertWDS.Title>{title}</AlertWDS.Title>}
                {children}
            </AlertWDS.Content>
        </AlertWDS>
    );
};

export { Alert };
export type { Props as AlertProps, AlertSeverity };
